import Vue from 'vue';
import batchIngredienceTransformer from '../../transformers/batchIngredience';
import store from '../../store';

const success = ({ data }) => batchIngredienceTransformer.fetch(data);

const failed = (error, reject) => reject(error);

export default id => (
  new Promise((resolve, reject) => {
    const batchIngrediences = store.state.batchIngredience.items.filter(p => (
      id.toString() === p.id.toString()
    ));

    if (batchIngrediences.length > 0) {
      return resolve(batchIngrediences[0]);
    }

    return Vue.$http.get(`/production/batch_ingredience/${id}`)
      .then((response) => {
        resolve(success(response));
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/batchIngredience/show.js